<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingPelList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/selfTestPelletizingCal', query:{id: selfTestId}}">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingCal')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <div class="col-lg-2">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('selfTestPelletizingCal')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
      </div>-->
    </div>
    <section class="app-content">
      <div id="selfTestPelletizingCalTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="selfTestPelletizingCal" :singleChoice="true" disableDelete></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingCal";
import { gridFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingCal";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizingCal/getField",
  mutationType: "selfTestPelletizingCal/updateField"
});

export default {
  name: "selfTestPelletizingCalList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(filterFields),

    ...mapState("selfTestPelletizingCal", {
      rows: state => state.rows,
      tableColumns: gridFields,
      entity: state => state.entity,
      baseModuleUrl: state => state.baseModuleUrl,
      selfTestId: state => state.selfTestId
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter", "MMFNew"]),
    ...mapActions("selfTestPelletizingCal", ["Load"])
  },
  created() {
   this.Load(this.$route.query.id);
  }
};
</script>
